/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, March 29th 2024, 10:43:35 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface LibraryAssetsTopBarProps {
  title: string;
  description: string;
  newUploadAction: React.ReactNode;
}
export const LibraryAssetsTopBar = ({ title, description, newUploadAction }: LibraryAssetsTopBarProps) => (
  <Stack direction="row">
    <Stack>
      <Typography color="primary" sx={{ fontWeight: 700, fontSize: 24 }}>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {description}
      </Typography>
    </Stack>
    {newUploadAction}
  </Stack>
);
